import { forwardRef, memo, useMemo } from 'react';
import { BzTab } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { DEFAULT_MANAGE_COLUMN_PROFILE_NAME, GRID_VIEW, MANAGE_COLUMNS_VIEW_TYPES, ORDERS_TABKEY, ORDER_TYPES, POSITION_TYPES } from '../../utils/global_variables';
import { setCurrentPage } from '../../redux/actions/orders';
import { updateDefaultManageColumnName, updateStrViewType } from '../../redux/actions/watchlist';
import { handleModal } from '../../redux/actions/modals';
import { Col, Container, Dropdown, Row } from 'react-bootstrap';
import { bIsProd } from '../../utils/global_functions';



const CustomDropdownToggle = forwardRef(({ children, onClick, className }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </div>
));
const OrdersPositionsTabs = (props) => {

    const { arrOrdersNetPostion, activeTabs, ordersNetPositionCount, setActiveTabs, clearAll, ordersTabKey

    } = props;
    const dispatch = useDispatch();
    // Azeem K : 13-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    const nAllSingleScripOrdersLength = useSelector(state => state?.orders?.nAllSingleScripOrdersLength);
    // Azeem K : 13-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
    const objGTDMetaData = useSelector(state => state.orders.objGTDMetaData);

    const nAllSpreadOrdersLength = useSelector(state => state?.orders?.nAllSpreadOrdersLength);
    const gtdOrders = useSelector(state => state.orders.gtdOrders);
    // Ajitesh 15-07-2024 - Get new order count from state after pagination
    const nAllMultilegOrdersLength = useSelector(state => state?.orders?.nAllMultilegOrdersLength);
    const objEquitySIPMetaData = useSelector(state => state.orders.objEquitySIPMetaData);
    const handleTabClick = async (each) => {

        setActiveTabs(each.tab_key);
        clearAll();
        if (activeTabs !== each.tab_key) {
            dispatch(setCurrentPage(1));
        }

    };
    /*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - Start*/
    const todaysPostions = useSelector(state => state?.netPosition?.todaysPostions);
    const overAllPositions = useSelector(state => state?.netPosition?.overAllPositions);

    const todaysCount = useMemo(() => todaysPostions?.length, [todaysPostions]);
    const overAllCount = useMemo(() => overAllPositions?.length, [overAllPositions]);
    /*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - End*/
    const allOrders = useSelector(state => state?.orders?.allOrders);
    const arrCompletedOrders = useSelector(state => state?.orders?.arrCompletedOrders);
    const arrOpenOrders = useSelector(state => state?.orders?.arrOpenOrders);

    const gtdAllOrders = useSelector(state => state.orders.gtdOrders);
    const gtdOpenOrders = useSelector(state => state.orders.gtdOpenOrders);
    const gtdCompletedOrders = useSelector(state => state.orders.gtdCompletedOrders);

    const MultLegAllOrders = useSelector(state => state?.orders?.arrMultilegAllOrders);
    const arrMultilegCompletedOrders = useSelector(state => state?.orders?.arrMultilegCompletedOrders);
    const arrMultilegOpenOrders = useSelector(state => state?.orders?.arrMultilegOpenOrders);

    const arrAllSipOrders = useSelector(state => state.orders.arrAllSipOrders);
    const arrOpenSipOrders = useSelector(state => state.orders.arrOpenSipOrders);
    const arrCompletedSipOrders = useSelector(state => state.orders.arrCompletedSipOrders);

    const arrSpreadAllOrders = useSelector(state => state?.orders?.arrSpreadAllOrders);
    const arrSpreadOpenOrders = useSelector(state => state?.orders?.arrSpreadOpenOrders);
    const arrSpreadCompletedOrders = useSelector(state => state?.orders?.arrSpreadCompletedOrders);

    const isOrderReportShow = useMemo(() => {
        switch (activeTabs) {
            case POSITION_TYPES.OVERALL: {
                if (overAllPositions?.length) {
                    return true;
                } else { return false; }
            }
            case POSITION_TYPES.TODAYS: {
                if (todaysPostions?.length) {
                    return true;
                } else { return false; }
            }
            case ORDER_TYPES.MULTI_LEG: {
                if ((MultLegAllOrders?.length && ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) || (arrMultilegOpenOrders?.length && ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) || (arrMultilegCompletedOrders?.length && ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS)) {
                    return true;
                } else {
                    return false;
                }
            }
            case ORDER_TYPES.GOOD_TILL_DATE: {
                if ((gtdAllOrders?.length && ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) || (gtdCompletedOrders?.length && ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS) || (gtdOpenOrders?.length && ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS)) {
                    return true;
                } else {
                    return false;
                }
            }
            case ORDER_TYPES.SPREAD: {
                if ((arrSpreadAllOrders?.length && ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) || (arrSpreadCompletedOrders?.length && ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS) || (arrSpreadOpenOrders?.length && ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS)) {
                    return true;
                } else {
                    return false;
                }
            }
            case ORDER_TYPES.SINGLE_SCRIP: {
                if ((allOrders?.length && ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) || (arrCompletedOrders?.length && ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS) || (arrOpenOrders?.length && ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS)) {
                    return true;
                } else {
                    return false;
                }
            }
            case ORDER_TYPES.EQUITY_SIP: {
                if ((arrAllSipOrders?.length && ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) || (arrCompletedSipOrders?.length && ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS) || (arrOpenSipOrders?.length && ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS)) {
                    return true;
                } else {
                    return false;
                }
            }
            default: {
                return false;
            }
        }
    }, [activeTabs, overAllPositions, todaysPostions, allOrders, arrOpenOrders, arrCompletedOrders, gtdAllOrders, gtdCompletedOrders, gtdOpenOrders, MultLegAllOrders, arrMultilegOpenOrders, arrMultilegCompletedOrders, arrOpenSipOrders, arrCompletedSipOrders, arrAllSipOrders, arrSpreadCompletedOrders, arrSpreadOpenOrders, arrSpreadAllOrders]);

    const futureKebabDropdownoptionsOnClickHandler = (value) => {
        if (value === "0") {
            dispatch(handleModal([{ "WATCHLIST_MANAGE_COLUMNS_MODAL": true }]));
            if (activeTabs === ORDER_TYPES.EQUITY_SIP) {
                dispatch(updateDefaultManageColumnName(DEFAULT_MANAGE_COLUMN_PROFILE_NAME.ORDER_BOOK_SIP));
                dispatch(updateStrViewType(MANAGE_COLUMNS_VIEW_TYPES?.ORDER_EQUITY_SIP_VIEW_TYPE));
            } else if (activeTabs === ORDER_TYPES.SINGLE_SCRIP) {
                dispatch(updateDefaultManageColumnName(DEFAULT_MANAGE_COLUMN_PROFILE_NAME.ORDER_SINGLE));
                dispatch(updateStrViewType(MANAGE_COLUMNS_VIEW_TYPES?.ORDER_SINGLE_SCRIP_VIEW_TYPE));
            } else if (activeTabs === ORDER_TYPES.SPREAD) {
                dispatch(updateDefaultManageColumnName(DEFAULT_MANAGE_COLUMN_PROFILE_NAME.ORDER_SPREAD));
                dispatch(updateStrViewType(MANAGE_COLUMNS_VIEW_TYPES?.ORDER_SPREAD_VIEW_TYPE));
            } else if (activeTabs === ORDER_TYPES.GOOD_TILL_DATE) {
                dispatch(updateDefaultManageColumnName(DEFAULT_MANAGE_COLUMN_PROFILE_NAME.ORDER_GTD));
                dispatch(updateStrViewType(MANAGE_COLUMNS_VIEW_TYPES?.ORDER_GOOD_TILL_DATE_VIEW_TYPE));
            } else if (activeTabs === ORDER_TYPES.MULTI_LEG) {
                dispatch(updateDefaultManageColumnName(DEFAULT_MANAGE_COLUMN_PROFILE_NAME.ORDER_MULTI_SCRIPS));
                dispatch(updateStrViewType(MANAGE_COLUMNS_VIEW_TYPES?.ORDER_MULTI_LEG_VIEW_TYPE));
            } else if ((activeTabs === POSITION_TYPES.TODAYS) || (activeTabs === POSITION_TYPES.OVERALL)) {
                dispatch(updateDefaultManageColumnName(DEFAULT_MANAGE_COLUMN_PROFILE_NAME.NETPOSITION));
                dispatch(updateStrViewType(MANAGE_COLUMNS_VIEW_TYPES?.NET_POSITION_VIEW_TYPE));
            }
        } else {
            dispatch(handleModal([{ "POSITION_REPORT": true }]));
        }

    };
    const arrOrdersKebabOtions = useMemo(() => [
        { id: '0', value: '0', content: GRID_VIEW.MANAGE_COLUMNS_VIEW },
        { id: '1', value: '1', content: ((activeTabs === POSITION_TYPES.TODAYS) || (activeTabs === POSITION_TYPES.OVERALL)) ? 'Position Report' : 'Orders Report' },
    ], [activeTabs]);

    return (
        <>
            {
                arrOrdersNetPostion?.map((each) => (
                    <BzTab className='OrderTab' tabKey={`tab${each.tab_key}`} key={each.id} isActive={activeTabs === each.tab_key} onClick={() => handleTabClick(each)}>

                        <div className='d-flex align-items-center gap-2'>

                            <div className={`navtitle ${activeTabs === each.tab_key ? 'color-active-text' : ''} mt-1 me-1`}>
                                {each?.tab_key === ORDER_TYPES.EQUITY_SIP ? (`${each.name}(${objEquitySIPMetaData?.total_records || 0})`) : each?.tab_key === ORDER_TYPES.SINGLE_SCRIP ? (`${each.name}(${nAllSingleScripOrdersLength || 0})`) : each?.tab_key === ORDER_TYPES.SPREAD ? (`${each.name}(${nAllSpreadOrdersLength || 0})`) : each?.tab_key === ORDER_TYPES.GOOD_TILL_DATE ? (`${each.name}(${objGTDMetaData?.total_records || 0})`) : each?.tab_key === ORDER_TYPES.MULTI_LEG ? (`${each.name}(${nAllMultilegOrdersLength || 0})`) : <> {each?.name}({each.name === 'Today\'s' ? todaysCount : each.name === 'Overall' ? overAllCount : ordersNetPositionCount})</>}
                            </div>
                            {/* Azeem K : 30-11-2023 : commented kabab menu in orders tab  ---start */}

                            {/* {activeTabs === each.tab_key ?
                                <>
                                    <div className='clear-background me-2'>
                                        <TabsMenus arrKababDropdown={arrKababDropdown} kababDropdownoptionsOnClickHandler={kababDropdownoptionsOnClickHandler}>
                                        </TabsMenus>
                                    </div>
                                </>
                                : null} */}
                            {/* Azeem K : 30-11-2023 : commented kabab menu in orders tab  ---End */}
                            <Dropdown className='dropdown-kebab'>
                                <Dropdown.Toggle as={CustomDropdownToggle} className='p-0 m-0'>
                                    <div className={`icon-14 icon-kebab d-flex flex-shrink-0 mt-1 ${activeTabs === each.tab_key ? 'icon-light' : 'icon-dark'}`}></div>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {
                                        arrOrdersKebabOtions?.map((eachOption) => (
                                            < Dropdown.Item disabled={!isOrderReportShow} key={eachOption.id} value={eachOption.value} onClick={(e) => futureKebabDropdownoptionsOnClickHandler(eachOption.value)}>
                                                <Container fluid className='p-0'>
                                                    <Row className='g-0' >
                                                        <Col md={12} className='d-flex justify-content-between align-self-center'>
                                                            <div className='text-nowrap text-truncate'>{eachOption.content}</div>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Dropdown.Item>
                                        ))
                                    }
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </BzTab >))
            }
        </>
    );

};

export default memo(OrdersPositionsTabs);